import { render, staticRenderFns } from "./NewBuyingAgentModal.vue?vue&type=template&id=0f856753&scoped=true&"
import script from "./NewBuyingAgentModal.vue?vue&type=script&lang=js&"
export * from "./NewBuyingAgentModal.vue?vue&type=script&lang=js&"
import style0 from "./NewBuyingAgentModal.vue?vue&type=style&index=0&id=0f856753&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f856753",
  null
  
)

export default component.exports